import React from "react";
import { GET } from "Common/api";
import _ from "lodash";

export default class Tree extends React.Component {
  async componentWillMount() {
    let nodes = this.props.nodes;

    if (!nodes) {
      nodes = await GET("/v1/users/adminunits");
    }

    var rootNode = buildNestedHierarchy(nodes);

    this.setState({ expanded: {}, rootNode, ready: true });
  }

  onToggleVisible(node) {
    this.setState((st) => ({
      expanded: { ...st.expanded, [node.id]: !st.expanded[node.id] },
    }));
  }

  renderLevel(n, i = 0) {
    let isExpanded = !!this.state.expanded[n.id];
    let expandClass = n.childNodes
      ? isExpanded
        ? "treeview-node-expanded"
        : "treeview-node-collapsed"
      : "treeview-node-leftpadding";

    return (
      <ul key={n.id}>
        <li data-id={n.id} className={i === 0 ? "" : "treeview-indent"}>
          <span
            className={expandClass}
            onClick={() => this.onToggleVisible(n)}
          />
          <input type="checkbox" data-id={n.id} />
          <span>{n.title}</span>
          {isExpanded && n.childNodes.map((c) => this.renderLevel(c, i + 1))}
        </li>
      </ul>
    );
  }

  render() {
    if (!this.state || !this.state.ready) return <div />;
    let nodes = this.state.nodes;

    return (
      <div>
        {this.state.rootNode &&
          this.state.rootNode.childNodes.map((c) => this.renderLevel(c))}
      </div>
    );
  }
}

function buildNestedHierarchy(nodes) {
  if (!nodes || !nodes.length) return nodes || [];
  var nodeObjs = _.zipObject(
    _.map(nodes, (n) => n.id),
    nodes,
  );
  var rootNodes = [];

  _.each(nodes, (n) => {
    var parent = nodeObjs[n.parentID];
    if (!parent) rootNodes.push(n);
    else {
      if (!parent.childNodes) parent.childNodes = [];
      parent.childNodes.push(n);
    }
  });

  return rootNodes[0];
}
